import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as authActions from 'action/auth'
import { translate } from 'react-i18next'
import Alert from 'component/utils/Alert'

class NoPermission extends Component {
  constructor(props) {
    super(props)

    this.state = { showConfirm: false }

    this.handleLogout = this.handleLogout.bind(this)
  }

  handleLogout() {
    const { logout, redirectToHome, dispatch } = this.props

    logout(dispatch)
    redirectToHome()
  }

  render() {
    const { translate } = this.props
    const textMessage = translate('no_permissions.do_not_have_access_text')
    return (
      <div>
        <Alert
          handleAlert={this.handleLogout}
          text={textMessage}
          translate={translate}
          size='lg'
        />
      </div>
    )
  }
}

NoPermission.propTypes = {
  translate: PropTypes.func,
  logout: PropTypes.func.isRequired,
  redirectToHome: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
}

/* istanbul ignore next */
const mapStateToProps = (
  /* istanbul ignore next */
  { auth }
) =>
  /* istanbul ignore next */
  ({ user: auth.user })

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authActions, dispatch)

const NoPermissionTransate = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(NoPermission)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoPermissionTransate)

export { NoPermission }
